// extracted by mini-css-extract-plugin
module.exports = {"container":"_2rTifU","contentWrapper":"_2zGugj","content":"_1D5bvh"};